'use strict';

angular.module('userRequestEditControllers')

.controller('SelectEmployeeSameAsModalController', ['$scope', 'editAccessRequestService', function ($scope, editAccessRequestService) {

    $scope.ctxSelectSameAs = {};

    $scope.searchEmployees = function () {
        var searchTerm = $scope.ctxSelectSameAs.searchTerm;
        if (_.isUndefined(searchTerm) || searchTerm.length < 3) {
            $scope.sameAsEmployees = [];
            return;
        }
        editAccessRequestService.sameAs.searchEmployees($scope.userRequest.UserAccessRequestID, searchTerm)
        .then(function (foundEmployees) {
            $scope.sameAsEmployees = foundEmployees;
        });
    }
}]);